import React, { FC, useRef } from "react";
import image from "../../../assets/images/logo/logo-removebg.png";

import {
  StyledWrap,
  StyledImg,
  StyledTitle,
  StyledDesc,
  StyledResetForm,
} from "./style";
import { FormGroup, Input, Label } from "../../UI/Forms/FormElements";
import { Button } from "../../UI/Button";
import { hasKey } from "../../../utils/methods";
import { useForm } from "react-hook-form";
import { StyledLabelWrap } from "../../ScreenLogin/SigninForm/style";
import { useTranslation } from "react-i18next";

type Props = {
  handleSubmitForm: (newPassword: string) => void;
};

const ChangePasswordForm: FC<Props> = ({ handleSubmitForm }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const password = useRef({});
  password.current = watch("password", "");
  const { t } = useTranslation();

  return (
    <StyledWrap>
      <StyledImg>
        <img src={image} alt="forgot password" />
      </StyledImg>
      <StyledTitle>{t("components.changePasswordForm.title")}</StyledTitle>
      <StyledDesc>{t("components.changePasswordForm.description")}</StyledDesc>
      <StyledResetForm>
        <form
          action="#"
          noValidate
          onSubmit={handleSubmit((data) => handleSubmitForm(data.password))}
        >
          <FormGroup mb="20px">
            <StyledLabelWrap>
              <Label display="block" mb="5px" htmlFor="email">
                {t("components.changePasswordForm.newPassword")}
              </Label>
            </StyledLabelWrap>
            <Input
              type="password"
              id="password"
              placeholder={t(
                "components.changePasswordForm.passwordPlaceholder"
              )}
              feedbackText={errors?.email?.message?.toString()}
              state={hasKey(errors, "password") ? "error" : "success"}
              showState={!!hasKey(errors, "password")}
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Minimum length is 8",
                },
              })}
            />
          </FormGroup>
          <FormGroup mb="20px">
            <StyledLabelWrap>
              <Label display="block" mb="5px" htmlFor="password">
                {t("components.changePasswordForm.confirmPassword")}
              </Label>
            </StyledLabelWrap>
            <Input
              id="confirmPassword"
              type="password"
              placeholder={t(
                "components.changePasswordForm.passwordPlaceholder"
              )}
              feedbackText={errors?.confirmPassword?.message?.toString()}
              state={hasKey(errors, "confirmPassword") ? "error" : "success"}
              showState={!!hasKey(errors, "confirmPassword")}
              {...register("confirmPassword", {
                validate: (value) =>
                  value === password.current || "La password non corrisponde",
              })}
            />
          </FormGroup>
          <Button type="submit" color="brand2" fullwidth>
            {t("components.changePasswordForm.button")}
          </Button>
        </form>
      </StyledResetForm>
    </StyledWrap>
  );
};

export default ChangePasswordForm;
